import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import {validatable} from 'components/utils';
import { Reception } from 'api';

class DropDownChonLoaiDonThu extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: []
    }
  }
  onChange(e) {
    this.props.onChange(e);
  }
  componentDidMount() {
    if (this.props.isTraCuu === true) {
      this.getNewLoaiDonThu();
    } else if (this.props.isDonCu === true) {
      this.getNewLoaiDonThuCu();
    } else {
      this.setState({data: this.props.data})
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data && this.props.isTraCuu === false) {
      this.getNewLoaiDonThuCu();
    }
  }
  getNewLoaiDonThu() {
    let state = this.state;
    Reception.actions.getLoaiDonThu.request(null, {isTraCuu: this.props.isTraCuu}).then(res => {
      if (res.data) {
        let loaiDon = res.data;
        // loaiDon = loaiDon.filter(item => item.giaTri !== "DON_TO_CAO");
        state.data = loaiDon;
      } else {
        state.data = [];
      }
      this.setState({state});
    });
  }
  getNewLoaiDonThuCu() {
    let state = this.state;
    Reception.actions.getLoaiDonThu.request(null, {isDonCu: this.props.isDonCu}).then(res => {
      if (res.data) {
        let loaiDonThu = res.data;
        if (this.props.page === 'trangChu') {
          loaiDonThu = loaiDonThu.filter(item => item.giaTri !== 'DON_TRANH_CHAP_DAT' && item.giaTri !== "DON_KIEN_NGHI_PHAN_ANH");
        }
        state.data = loaiDonThu;
      } else {
        state.data = [];
      }
      this.setState({state});
    });
  }
  render() {
    return (
      <DropDown
        label={this.props.label}
        selectedValue={this.props.selectedValue}
        require={this.props.require}
        isValid={this.props.isValid}
        options={ this.state.data }
        keyName='giaTri'
        valueName='ten'
        onChange={ this.onChange.bind(this) }
        placeholder={ this.props.placeholder }
        className={this.props.className}
        bindValidator={this} channel="formTaoDon"
        name={this.props.name}/>
    )
  }
}

DropDownChonLoaiDonThu.defaultProps = {
  className: 'input-group',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  label: 'Phân loại đơn',
  selectedValue: '',
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  name: '',
  data: [],
  isTraCuu: false,
  isDonCu: false
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.loaiDonThu
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonLoaiDonThu));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonloaidonthu.jsx